import type { CollectionId } from "@anaconda/core/nft-collection/types"
import { cn } from "@rarible_int/anaconda_ui_components"
import Link from "next/link"
import { getCollectionHref } from "../../../navigation/collection"

interface Props {
  collectionId: CollectionId
  children: React.ReactNode
  isHolding?: boolean
  className?: string
}

export function CollectionLink({
  collectionId,
  children,
  isHolding,
  className,
}: Props) {
  const href = isHolding
    ? `${getCollectionHref(collectionId)}/my-items`
    : getCollectionHref(collectionId)
  return (
    <Link className={cn("block p-2", className)} href={href} prefetch={false}>
      {children}
    </Link>
  )
}
